import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.css'],
  providers:[MessageService,ConfirmationService]
})
export class AppsComponent implements OnInit {
  appsList:any[]=[];
  loading:boolean=true;
  expandedRows:any = {};

  constructor(
     private apiService: ApiService,
     private globalService: GlobalService,
     private messageService: MessageService,
     public router: Router,
 
  ) { }
 
  ngOnInit(): void {
     this.apiService.get('organizationchart/getapps',{}).subscribe((data)=>{
      this.appsList=data.Result;
      this.loading=false;
      
      
     });

  }
 
  expandAll() {
      this.expandedRows = this.appsList.reduce((acc, p) => (acc[p.id] = true) && acc, {});
  }

  collapseAll() {
      this.expandedRows = {};
  }

  nuovopermesso(app){
    this.router.navigateByUrl('dashboard/adminapps-permits-edit/'+app.id+'/'+app.name+'/new');
  }

  editPermit(app,permesso){
    this.router.navigateByUrl('dashboard/adminapps-permits-edit/'+app.id+'/'+app.name+'/update/'+permesso.id); 
  }

  nuovaapp(){
    this.router.navigateByUrl('dashboard/adminapp-edit/new');
  }
  editApp(app){
   this.router.navigateByUrl('dashboard/adminapp-edit/update/'+app.id); 
  }
}
